// Externe links configuratie
// Zet hier de definitieve webshop-URL van de leverancier zodra beschikbaar.
export const SHOP_URL = "https://www.jmsport.be/teamwear/clubshops/inkad-diegem.html";
